export enum StreamCategory {
  MATERIAL_STREAM = 'material-stream',
  WATER_MATERIAL_STREAM = 'water-material-stream',
  FUEL_GAS_MATERIAL_STREAM = 'fuel-gas-material-stream',
}
